<template>
    <div>
        <div class="header__reviews text-center my-5 pt-4" v-if="type === 'both' || type === 'header'">
            <h3 class="font-weight-bold">
                Average Customer Rating:
            </h3>

            <div class="d-flex flex-wrap justify-content-center align-items-center my-3">
                <star-rating class="mr-2" :read-only="true" :star-size="25" :rounded-corners="true" :border-width="1"
                    border-color="#f5c400" :show-rating="false" :increment="0.01" :rating="averageStars"
                    active-color="#ffd429" inactive-color="#969696"
                    :star-points="[23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17]" />

                <p class="d-flex align-items-center font-weight-bold ml-2" v-if="averageStars &gt; 0.0">
                    <span class="average__stars">{{ averageStars }}</span>
                    <span class="mx-2 average__out-of">out of</span>
                    <span class="average__stars">5!</span>
                </p>
            </div>

            <h4 class="font-weight-bold">
                Based on {{ totalReviews }} customer reviews
            </h4>
        </div>

        <div class="d-flex flex-column align-items-center" :class="{ 'mt-3': type === 'reviews' }"
            v-if="type === 'both' || type === 'reviews'">
              <div class="d-flex" style="margin-top: 1em">
                <a v-if="linkToGmb && placeId" :style="`${linkColor ? 'color: #' + linkColor : ''}`" target="_blank"
                    :href="`https://search.google.com/local/reviews?placeid=${placeId}`">{{ linkText &&
                        linkText.length ?
                        linkText : "Read more of our reviews" }}</a>
            </div>
            <template v-for="(review, index) in reviews">
                <card :key="index">
                    <div class="d-flex align-items-center" id="container" style="padding: 1em !important;">
                        <div>
                            <div class="d-flex align-items-center">
                                <i class="fas fa-user-circle"
                                    style="font-size: 3em; color: #0374D7; margin-right: .5em; margin-bottom: 25px;"></i>
                                <div class="d-flex flex-column align-items-start" id="reviews-info" style="width: 140px;">
                                    <star-rating v-if="showRating(review)" :read-only="true" :star-size="20"
                                        :show-rating="false" :rating="review.rating" active-color="#ffd429"
                                        inactive-color="#EDF0F2"
                                        :star-points="[23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17]" />
                                    <div v-else class="recommendation" :class="recommendation_type(review)">
                                        {{ review.recommendation_type }}
                                    </div>
                                    <p class="my-1" style="font-size: 0.9em; font-weight: bold;">
                                        {{ review.reviewer_name }}</p>
                                    <p class="mb-0" style="font-size: 0.9em;">
                                        {{ review.review_date | fromNow }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="review-body">
                            <text-expand v-if="review.body" :body="review.body" :limit="50" text-align="justify">
                                <span v-html="review.body"></span>
                            </text-expand>
                            <p class="text-justify m-0" v-if="!review.body"> </p>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex justify-content-end align-items-center" style="padding-bottom: 1em;">
                            <img :src="`/img/${review.origin}-logo.png`"
                                style="margin-right: 1em; max-height: 75px; max-width: 100px;" />
                        </div>
                    </div>
                </card>
            </template>
            <div class="d-flex flex-column align-items-start" style="width: 100%; max-width: 1100px">
                <p>{{ reviews && reviews.length ? reviews.length.toString() : "0" }} of {{
                    totalReviews }} reviews</p>
            </div>
          
        </div>
</div>
</template>

<script>
import StarRating from 'vue-star-rating';
import moment from 'moment'

export default {
    props: [
        'reviews',
        'bgColor',
        'type',
        'linkToGmb',
        'linkText',
        'linkColor',
        'placeId',
        'totalReviews',
        'averageStars'
    ],

    components: {
        StarRating
    },

    filter: {
        fromNow(value) {
            return moment(value).fromNow();
        }
    },

    created() {
        if (this.bgColor) {
            let bgColor = this.bgColor.indexOf('rgba') > -1 ? this.bgColor : `#${this.bgColor}`;

            document.body.style.backgroundColor = `${bgColor}`;
        }
    },

    methods: {
        showRating(review) {
            if (review.origin === 'facebook') {
                return false;
            }

            return true;
        },

        recommendation_type(review) {
            if (review.recommendation_type === 'negative') {
                return 'recommendation-negative';
            }

            return 'recommendation-positive';
        }
    }

};
</script>

<style lang="scss" scoped>
.header__reviews {
    color: #0F467E;
}

.average__stars {
    font-size: 2rem;
}

.average__out-of {
    font-size: 1.2rem;
}

#review-body {
    width: 70%;
}

.card {
    max-width: 1100px;
    margin-bottom: 1em;
}

.recommendation {
    text-transform: capitalize;
    font-weight: 900;
}

.recommendation-positive {
    color: green;
}

.recommendation-negative {
    color: red;
}

@media screen and (max-width: 767px) {
    #container {
        flex-direction: column;
    }

    #reviews-info {
        margin-bottom: 1em;
    }

    #review-body {
        width: 100%;
    }
}
</style>
